import { WarningAmberRounded, InfoOutlined } from '@mui/icons-material'
import { BookingStatusVariant } from './bookingStatus'

export interface BookingStatusConfig {
    icon: React.ComponentType<any>
    iconColor: 'error' | 'info' | 'warning'
    bgColor: string
}

export const bookingStatusConfig: Record<BookingStatusVariant, BookingStatusConfig> = {
    failed: {
        icon: WarningAmberRounded,
        iconColor: 'error',
        bgColor: 'error.light'
    },
    pending: {
        icon: InfoOutlined,
        iconColor: 'info',
        bgColor: 'info.light'
    },
    refund: {
        icon: WarningAmberRounded,
        iconColor: 'warning',
        bgColor: 'warning.light'
    }
}
